<template>
<div class="sal-button-container">
    <div class="v-s-boxes py-3">
      <div v-for="(salutation, index) in currentSalutation" class="sal-buttons">
        <input type="radio" class="variation-input-button sal-radio" :id="salutation.key + returnAddressType()" :value="salutation.key"
        :selected="addressData.gender === salutation.key && checkGenderCompany(salutation.key)"
         @change="emitInputEvent($event.target.value)"
        v-model="addressData.gender">
        <label
        :class="'btn btn-outline-primary' + { 'active': isActive(salutation.key) }"
        :for="salutation.key + returnAddressType()">{{ salutation.name }}</label>
      </div>
    </div>
  </div>
</template>
<script>
import { isNullOrUndefined } from "../../helper/utils";

export default {

    props:
    {
        addressData:
        {
            type: Object,
            required: true
        },
        addressType:
        {
            type: [Number, String],
            default: 1
        },
        enabledAddressFields:
        {
            type: Object,
            default: () => []
        },
        defaultSalutation: {
            type: String,
            default: "male"
        }
    },

    data()
    {
        return {
            salutations: [
                {
                    key: "male",
                    name: "addressSalutationMale"
                },
                {
                    key: "female",
                    name: "addressSalutationFemale"
                },
                {
                    key: "diverse",
                    name: "addressSalutationDiverse"
                },
                {
                    key: "company",
                    name: "addressSalutationCompany"
                }
            ]
        };
    },

    computed:
    {


        currentSalutation()
        {
            const countryId = parseInt(this.addressData.countryId) || 1;
            const addressKey = parseInt(this.addressType) === 1 ? "billing_address" : "delivery_address";
            const countryKey = countryId === 12 ? "gb" : "de";

            const salutations = this.salutations.map(salutation =>
            {
                return {
                    key: salutation.key,
                    name: this.$translate("Ceres::Template." + salutation.name)
                };
            });

            if (this.enabledAddressFields[countryKey].includes(`${addressKey}.name1`))
            {
                return salutations;
            }

            return salutations.filter(salutation => salutation.key !== "company");
        }
    },

    /**
     * Get the shipping countries
     */
    created()
    {
        this.$options.template = this.template;

        let selectedSalutation = this.defaultSalutation;

        if (isNullOrUndefined(selectedSalutation))
        {
            selectedSalutation = this.currentSalutation[0].key;
        }

        this.emitInputEvent(selectedSalutation);
    },

    methods:
    {

      isActive(key)
      {
        if((this.addressData.gender === key) && this.checkGenderCompany(key))
        {
          return true;
        }
        return false;
      },
        /* Return Address Type for unique ID's */
        returnAddressType()
        {
            return parseInt(this.addressType);
        },

        emitInputEvent(value)
        {
            this.$emit("input", { field: "gender", value: value });
            this.$emit("input", { field: "name1", value: "" });
            this.$emit("input", { field: "name2", value: "" });
            this.$emit("input", { field: "name3", value: "" });
            this.$emit("input", { field: "vatNumber", value: "" });
            this.$emit("input", { field: "contactPerson", value: "" });
        },

        checkGenderCompany(gender)
        {
            if (gender === "company")
            {
                return (this.addressData.name1 !== null) || (this.addressData.name1 !== "");
            }
            return true;
        }
    },

    watch:
    {
        currentSalutation(newVal, oldVal)
        {
            if (newVal !== oldVal)
            {
                const selectedSalutation = this.addressData.gender;

                // cleanse the current selected salutation, if it's not longer included in the choice
                if (!newVal.map(salutation => salutation.key).includes(selectedSalutation))
                {
                    this.emitInputEvent(newVal[0].key);
                }
            }
        }
    }
}
</script>
